<script setup>
import axios from 'axios'
import { ref, onMounted } from 'vue'

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faTag } from "@fortawesome/free-solid-svg-icons"

library.add(faTag)

axios.defaults.headers.common = {
  'X-Requested-With': 'XMLHttpRequest',
};

const data = ref()
const getData = async() => {
  await axios.get("./php/getTagList.php")
  .then((response) => {
    data.value = response.data
  })
}

onMounted(() => {
  getData()
})
</script>

<template>
  <h5>タグ</h5>
  <div v-for="list in data" :key="list.id">
    <a :href="list.url">
      <font-awesome-icon icon="fa-solid fa-tag" size="lg" />
      {{ list.name }}&nbsp;({{ list.count }})
    </a>
  </div>
</template>

<style scoped>
  div {
    margin: .4em 0;
    text-align: start;
  }
</style>